import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import React from 'react'
import { MUIThemeConfig } from './MUIThemeConfig'

const getInitialTheme = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const storedPrefs = window.localStorage.getItem('color-theme')
    if (typeof storedPrefs === 'string') {
      return 'light'
    }

    const userMedia = window.matchMedia('(prefers-color-scheme: dark)')
    if (userMedia.matches) {
      return 'light'
    }
  }

  return 'light' // light theme as the default;
}
const muiTheme = createTheme(MUIThemeConfig)

export const ThemeContext = React.createContext()

export const ThemeProvider = ({ initialTheme, children }) => {
  const [theme, setTheme] = React.useState(getInitialTheme)
  const rawSetTheme = (rawTheme) => {
    const root = window.document.documentElement
    const isDark = rawTheme === 'dark'

    root.classList.remove(isDark ? 'light' : 'dark')
    root.classList.add(rawTheme)

    localStorage.setItem('color-theme', rawTheme)
  }

  if (initialTheme) {
    rawSetTheme(initialTheme)
  }

  React.useEffect(() => {
    rawSetTheme(theme)
  }, [theme])

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      <MuiThemeProvider 
      theme={muiTheme}
      >{children}</MuiThemeProvider>
    </ThemeContext.Provider>
  )
}
